var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgElipsis(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Elipsis",
    xmlns: "http://www.w3.org/2000/svg",
    width: 3,
    height: 13,
    viewBox: "0 0 3 13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_20",
    "data-name": "Ellipse 20",
    fill: "#14a4c2",
    stroke: "#14a4c2",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.5,
    cy: 1.417,
    rx: 1.5,
    ry: 1.417,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.5,
    cy: 1.417,
    rx: 1,
    ry: 0.917,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_21",
    "data-name": "Ellipse 21",
    transform: "translate(0 5.083)",
    fill: "#14a4c2",
    stroke: "#14a4c2",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.5,
    cy: 1.417,
    rx: 1.5,
    ry: 1.417,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.5,
    cy: 1.417,
    rx: 1,
    ry: 0.917,
    fill: "none"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_22",
    "data-name": "Ellipse 22",
    transform: "translate(0 10.167)",
    fill: "#14a4c2",
    stroke: "#14a4c2",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.5,
    cy: 1.417,
    rx: 1.5,
    ry: 1.417,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.5,
    cy: 1.417,
    rx: 1,
    ry: 0.917,
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElipsis);
export default __webpack_public_path__ + "static/media/Elipsis.bcfd5ac07160421314bef29a0cbe1d15.svg";
export { ForwardRef as ReactComponent };